import React from "react";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import { DataGrid } from "@mui/x-data-grid";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import SuiBox from "components/SuiBox";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import usePermissions from "./components/permissions";

const PermissionsManager = () => {
  const {
    groups,
    selectedGroup,
    setSelectedGroup,
    permissions,
    updatePermission,
    savePermissions,
    loadingGroups,
    savingPermissions,
    error,
  } = usePermissions();

  const columns = [
    {
      field: "name",
      headerName: "Página",
      flex: 1,
      renderCell: (params) => (
        <strong style={{ fontWeight: params.row.isTitle ? "bold" : "normal" }}>
          {params.value}
        </strong>
      ),
    },
    {
      field: "route",
      headerName: "Ruta",
      flex: 1,
      renderCell: (params) => {
        if (params.row.isTitle) {
          return <em>Titulo</em>;
        }
        return params.value;
      },
    },
    {
      field: "has_access",
      headerName: "Acceso",
      width: 150,
      renderCell: (params) => (
        <Checkbox
          checked={params.value}
          onChange={(e) => updatePermission(params.row.id, e.target.checked)}
          color="primary"
        />
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox mb={3}>
        <Grid container justifyContent="left">
          <Grid item xs={12} md={8} lg={6}>
            <SuiBox p={3} shadow="lg" borderRadius="lg" bgcolor="background.paper">
              <h2>ROLES</h2>

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              {!loadingGroups && (
                <Autocomplete
                  disablePortal
                  options={groups}
                  getOptionLabel={(option) => option.name}
                  sx={{ mb: 3 }}
                  renderInput={(params) => <TextField {...params} />}
                  value={selectedGroup}
                  onChange={(_, newValue) => setSelectedGroup(newValue)}
                />
              )}

              {loadingGroups && <p>Cargando grupos...</p>}

              {selectedGroup && (
                <>
                  <Paper sx={{ height: 400, width: "100%", mb: 2 }}>
                    <DataGrid
                      rows={permissions}
                      columns={columns}
                      pageSizeOptions={[]}
                      pageSize={10}
                      pagination
                      disableSelectionOnClick
                    />
                  </Paper>
                  <Button
                    variant="outlined"
                    onClick={savePermissions}
                    disabled={savingPermissions}
                    fullWidth
                    sx={{
                      color: "primary.main",
                      borderColor: "primary.main",
                    }}
                  >
                    {savingPermissions ? "Guardando..." : "Guardar Permisos"}
                  </Button>
                </>
              )}
            </SuiBox>
          </Grid>
        </Grid>
      </SuiBox>
    </DashboardLayout>
  );
};

export default PermissionsManager;
